/* ============================================================
   Build a Box — Vitadrop
   State + rendering for the product grid, summary panel (desktop)
   and bottom dock (mobile), plus add-to-cart with selling plan +
   Appstle line-item properties. One instance per section.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function defaultTo(n, p, t, d) {
      n = (n || 0).toString();
      p = isNaN(p) ? 2 : p;
      t = t === undefined ? ',' : t;
      d = d === undefined ? '.' : d;
      var num = (parseFloat(n) / 100).toFixed(p);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      var centsPart = parts[1] ? d + parts[1] : '';
      return dollars + centsPart;
    }

    switch (fmt.match(placeholder)[1]) {
      case 'amount':
        value = defaultTo(cents, 2);
        break;
      case 'amount_no_decimals':
        value = defaultTo(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = defaultTo(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = defaultTo(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = defaultTo(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = defaultTo(cents, 0, ' ', '');
        break;
      default:
        value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- one Build-a-Box instance ---------- */
  function BuildABox(root) {
    var sectionId = root.id.replace(/^bab-/, '');
    var data = (window.BAB && window.BAB[sectionId]) || { products: [] };
    var products = data.products || [];
    if (!products.length) return;

    var cfg = {
      max: parseInt(root.dataset.max, 10) || 5,
      unlimited: root.dataset.unlimited === 'true',
      min: parseInt(root.dataset.min, 10) || 2,
      discSub: parseFloat(root.dataset.discSub) || 0,
      discOnce: parseFloat(root.dataset.discOnce) || 0,
      defaultPlan: root.dataset.defaultPlan === 'once' ? 'once' : 'subscribe',
      redirect: root.dataset.redirect === 'checkout' ? 'checkout' : 'cart',
      sellingPlan: (root.dataset.sellingPlan || '').trim(),
      moneyFormat: root.dataset.moneyFormat || '${{amount}}',
      props: [],
      groupProp: (root.dataset.groupProp || '').trim(),
      boxId: (root.dataset.boxId || '').trim(),
      boxName: (root.dataset.boxName || '').trim(),
      discountCode: (root.dataset.discountCode || '').trim(),
      discountCodeSubscribe: (root.dataset.discountCodeSubscribe || '').trim(),
      discountCodeOnce: (root.dataset.discountCodeOnce || '').trim()
    };
    if (root.dataset.prop1Name) cfg.props.push([root.dataset.prop1Name, root.dataset.prop1Value || '']);
    if (root.dataset.prop2Name) cfg.props.push([root.dataset.prop2Name, root.dataset.prop2Value || '']);

    var routes = (window.theme && window.theme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';
    var cartUrl = routes.cart_url || '/cart';

    var byId = {};
    products.forEach(function (p) { byId[p.id] = p; });

    var qty = {};
    var plan = cfg.defaultPlan;
    var busy = false;

    var $ = function (sel) { return root.querySelector(sel); };
    function money(c) { return formatMoney(c, cfg.moneyFormat); }

    /* ----- derived ----- */
    function count() {
      var n = 0;
      for (var k in qty) n += qty[k];
      return n;
    }
    function selected() { return products.filter(function (p) { return qty[p.id] > 0; }); }
    function subtotal() {
      return products.reduce(function (s, p) { return s + p.price * (qty[p.id] || 0); }, 0);
    }
    function discountPct() { return plan === 'subscribe' ? cfg.discSub : cfg.discOnce; }
    function unlocked() { return count() >= cfg.min; }
    function savings() { return unlocked() ? Math.round(subtotal() * discountPct() / 100) : 0; }
    function total() { return subtotal() - savings(); }
    function isFull() { return cfg.unlimited ? false : count() >= cfg.max; }

    /* ----- mutations ----- */
    function add(id) {
      var p = byId[id];
      if (!p || !p.available || isFull()) return;
      qty[id] = (qty[id] || 0) + 1;
      render();
    }
    function remove(id) {
      if (!qty[id]) return;
      qty[id] -= 1;
      if (qty[id] <= 0) delete qty[id];
      render();
    }

    /* ----- card action (Add button <-> stepper) ----- */
    function renderCardAction(card) {
      var id = card.dataset.id;
      var p = byId[id];
      var q = qty[id] || 0;
      var action = card.querySelector('.bab-card__action');
      var badge = card.querySelector('.bab-card__badge');

      card.classList.toggle('is-selected', q > 0);
      if (badge) badge.textContent = q;

      if (!p || !p.available) {
        action.innerHTML = '<button type="button" class="bab-add" disabled>Sold out</button>';
        return;
      }
      if (q === 0) {
        var full = isFull();
        action.innerHTML = '<button type="button" class="bab-add' + (full ? ' is-full' : '') + '"' +
          (full ? ' disabled' : ' data-add') + '>' + (full ? 'Box full' : 'Add to box') + '</button>';
      } else {
        action.innerHTML = stepperHTML(q);
      }
    }

    function stepperHTML(q) {
      var addDisabled = isFull();
      return '' +
        '<div class="bab-stepper">' +
        '<button type="button" class="bab-stepper__btn" data-dec aria-label="Remove one">−</button>' +
        '<span class="bab-stepper__num">' + q + '</span>' +
        '<button type="button" class="bab-stepper__btn" data-inc aria-label="Add one"' +
        (addDisabled ? ' disabled' : '') + '>+</button>' +
        '</div>';
    }

    /* ----- panel item rows ----- */
    function renderItems() {
      var wrap = $('[data-items-wrap]');
      if (!wrap) return;
      var items = selected();
      wrap.innerHTML = '';

      if (!items.length) {
        var symbol = (products[0] && products[0].icon) || '';
        wrap.appendChild(el('div', 'bab-empty',
          '<img class="bab-empty__icon" src="' + symbol + '" alt="">' +
          '<div class="bab-empty__title">Your box is empty</div>' +
          '<div class="bab-empty__text">Add ' + (cfg.unlimited ? 'as many products as you like' : 'up to ' + cfg.max + ' products') + ' and save on every one.</div>'));
        return;
      }

      var list = el('div', 'bab-items');
      items.forEach(function (p) {
        var row = el('div', 'bab-item');
        row.setAttribute('data-id', p.id);
        row.innerHTML =
          '<span class="bab-chip" style="background:' + p.color + '1A">' +
            '<img src="' + p.icon + '" alt="">' +
          '</span>' +
          '<div class="bab-item__info">' +
            '<div class="bab-item__name">' + escapeHtml(p.title) + '</div>' +
            '<div class="bab-item__sub">' + money(p.price) +
              (p.flavour ? ' · ' + escapeHtml(p.flavour) : '') + '</div>' +
          '</div>' +
          stepperHTML(qty[p.id]);
        list.appendChild(row);
      });
      wrap.appendChild(list);
    }

    /* ----- capacity dots ----- */
    function renderDots() {
      var dots = $('[data-dots]');
      if (!dots) return;
      if (cfg.unlimited) { dots.style.display = 'none'; dots.innerHTML = ''; return; }
      var c = count();
      dots.innerHTML = '';
      for (var i = 0; i < cfg.max; i++) {
        var d = el('span', 'bab-dot' + (i < c ? ' is-on' : ''));
        dots.appendChild(d);
      }
    }

    /* ----- price breakdown ----- */
    function renderPrice() {
      var wrap = $('[data-price-wrap]');
      if (!wrap) return;
      var pct = discountPct();
      var rows = '<div class="bab-price__row"><span>Subtotal</span><span>' + money(subtotal()) + '</span></div>';
      if (unlocked() && savings() > 0) {
        rows += '<div class="bab-price__row bab-price__row--ink">' +
          '<span class="bab-price__label">Box discount<span class="bab-price__chip">−' + pct + '%</span></span>' +
          '<span>−' + money(savings()) + '</span></div>';
      } else {
        rows += '<div class="bab-price__row"><span>Add ' + cfg.min + ' to apply the discount</span><span>—</span></div>';
      }
      rows += '<div class="bab-price__divider"></div>';
      rows += '<div class="bab-price__row bab-price__row--strong"><span>Total</span><span>' + money(total()) + '</span></div>';
      wrap.innerHTML = rows;
    }

    /* ----- plan toggle ----- */
    function renderPlan() {
      root.querySelectorAll('[data-plan-opt]').forEach(function (b) {
        var active = b.dataset.planOpt === plan;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    /* ----- CTA + counts ----- */
    function renderCta() {
      var cta = $('[data-cta]');
      var label = $('[data-count-label]');
      var c = count();
      if (label) label.textContent = cfg.unlimited ? (c + (c === 1 ? ' item' : ' items')) : (c + ' of ' + cfg.max);
      if (!cta) return;
      cta.disabled = !unlocked() || busy;
      cta.classList.toggle('is-busy', busy);
      if (busy) {
        cta.textContent = 'Adding…';
      } else if (!unlocked()) {
        var need = cfg.min - c;
        cta.textContent = 'Add ' + need + (need === 1 ? ' more product' : ' more products');
      } else {
        cta.textContent = 'Add to cart · ' + money(total());
      }
    }

    /* ----- mobile dock ----- */
    function renderDock() {
      var pouches = $('[data-dock-pouches]');
      var save = $('[data-dock-save]');
      var totalEl = $('[data-dock-total]');
      var checkout = $('[data-dock-checkout]');
      var c = count();

      if (pouches) {
        pouches.innerHTML = '';
        if (c === 0) {
          pouches.appendChild(el('div', 'bab-dock__empty', 'Your box is empty — tap Add'));
        } else {
          selected().forEach(function (p) {
            for (var i = 0; i < qty[p.id]; i++) {
              var tile = el('button', 'bab-tile');
              tile.type = 'button';
              tile.setAttribute('data-remove', '');
              tile.setAttribute('data-id', p.id);
              tile.setAttribute('aria-label', 'Remove one ' + p.title);
              tile.innerHTML = (p.image ? '<img src="' + p.image + '" alt="">' :
                '<img src="' + p.icon + '" alt="">') +
                '<span class="bab-tile__x" aria-hidden="true">×</span>';
              pouches.appendChild(tile);
            }
          });
          if (!cfg.unlimited) {
            for (var j = c; j < cfg.max; j++) {
              pouches.appendChild(el('span', 'bab-tile bab-tile--empty'));
            }
          }
        }
      }

      if (save) {
        if (unlocked() && savings() > 0) {
          save.textContent = discountPct() + '% off · save ' + money(savings());
          save.classList.add('is-on');
        } else {
          save.textContent = 'Add ' + Math.max(cfg.min - c, 0) + ' more to save ' + discountPct() + '%';
          save.classList.remove('is-on');
        }
      }
      if (totalEl) totalEl.textContent = money(total());
      if (checkout) checkout.disabled = !unlocked() || busy;
    }

    function render() {
      root.querySelectorAll('.bab-card').forEach(renderCardAction);
      renderItems();
      renderDots();
      renderPrice();
      renderPlan();
      renderCta();
      renderDock();
    }

    /* ----- add to cart ----- */
    function buildItems() {
      // One shared id per box so the cart can render all of its lines as a
      // single locked "Your Box" block (see build-a-box-cart.js). This stops a
      // customer removing one item and keeping the box discount below the
      // minimum — the min is only enforced in the builder, not by the plan.
      var boxUid = cfg.groupProp
        ? ('box-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7))
        : '';

      return selected().map(function (p) {
        var properties = {};

        // Appstle Build-a-Box line-item properties — these mark each line as part
        // of the box so Appstle's discount recognises it. Must mirror what Appstle's
        // own /bb/ page sends.
        if (cfg.boxId) {
          properties['_appstle-bb-id'] = cfg.boxId;
          properties['_appstle-bb-product-sku'] = p.sku || '';
          properties['__appstle-bb-variants'] = p.variantId + ':' + qty[p.id];
          properties['__appstle-bb-name'] = cfg.boxName || 'Build a Box';
        }

        // Group-box marker: tags every line of this box with a shared id +
        // display name + plan so the cart can group and lock them together.
        if (boxUid) {
          properties[cfg.groupProp] = boxUid;
          properties['_box_name'] = cfg.boxName || 'Build a Box';
          properties['_box_plan'] = plan;
        }

        // Optional extra line-item properties (kept for flexibility).
        cfg.props.forEach(function (pair) { if (pair[0]) properties[pair[0]] = pair[1]; });

        var item = { id: p.variantId, quantity: qty[p.id] };
        if (Object.keys(properties).length) item.properties = properties;

        if (plan === 'subscribe') {
          var sp = cfg.sellingPlan || p.sellingPlanId;
          if (sp) item.selling_plan = sp;
        }
        return item;
      });
    }

    function checkout() {
      if (busy || !unlocked()) return;
      busy = true;
      renderCta();
      renderDock();

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          var dest = cfg.redirect === 'checkout' ? '/checkout' : cartUrl;
          // Apply the Appstle box discount by routing through Shopify's discount URL,
          // exactly like Appstle's own Build-a-Box page. The code persists to checkout.
          // Both plans fall back to the shared Appstle box code (per-plan codes optional).
          var code = (plan === 'subscribe' ? cfg.discountCodeSubscribe : cfg.discountCodeOnce) || cfg.discountCode;
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(dest);
          } else {
            window.location.href = dest;
          }
        })
        .catch(function (err) {
          busy = false;
          render();
          var msg = (err && (err.description || err.message)) || 'Sorry, we could not add your box to the cart.';
          window.alert(msg);
        });
    }

    /* ----- delegated events ----- */
    root.addEventListener('click', function (e) {
      var t = e.target;

      var addBtn = t.closest('[data-add]');
      if (addBtn) { add(addBtn.closest('.bab-card').dataset.id); return; }

      var inc = t.closest('[data-inc]');
      if (inc) { add(inc.closest('[data-id]').dataset.id); return; }

      var dec = t.closest('[data-dec]');
      if (dec) { remove(dec.closest('[data-id]').dataset.id); return; }

      var rem = t.closest('[data-remove]');
      if (rem) { remove(rem.dataset.id); return; }

      var planOpt = t.closest('[data-plan-opt]');
      if (planOpt) { plan = planOpt.dataset.planOpt; render(); return; }

      if (t.closest('[data-cta]') || t.closest('[data-dock-checkout]')) { checkout(); return; }
    });

    render();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    document.querySelectorAll('[data-bab-root]').forEach(function (root) {
      if (root.dataset.babReady) return;
      root.dataset.babReady = '1';
      try { BuildABox(root); } catch (e) { if (window.console) console.error('[build-a-box]', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-init when added/edited in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
